import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch, useSelector } from 'react-redux';
import { useAnalytics } from 'use-analytics';
import { useRouter } from 'next/router';
import { checkIsLoggedIn, checkSitePermission, logout as logoutAction } from '../../../../store/slices/user';
import { clearSearch } from '../../../../store/slices/tripSearch';
import { UserRolePermissions, doUseAuth0UniversalLogin } from '../../../../constants';
import Dropdown from '../../../Dropdown';

const navbarItemClasses = 'whitespace-normal w-full px-2 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900 col-span-5 text-left';

const NavbarDropdown = () => {
  const { track } = useAnalytics();
  const dispatch = useDispatch();
  const router = useRouter();
  const { logout, user } = useAuth0();
  const isLoggedIn = useSelector(checkIsLoggedIn);
  const { usefulLinks } = useSelector((store) => store.user);
  const canUnverifiedUserAccessSite = useSelector(
    checkSitePermission(UserRolePermissions.canUnverifiedUserAccessSite),
  );
  const canViewTrips = canUnverifiedUserAccessSite || (user && user.email_verified);

  const handleViewTrips = () => {
    if (isLoggedIn) {
      track('redirectToViewTrips');
      router.push('/trips');
    }
  };

  const handleSignOut = () => {
    track('handleSignOut');
    if (doUseAuth0UniversalLogin) {
      logout({ returnTo: window.location.origin });
      return;
    }
    dispatch(logoutAction());
    dispatch(clearSearch());
  };
  return isLoggedIn ? (
    <Dropdown className="cursor-pointer self-center">
      <Dropdown.Toggle>
        <span className="inline-block align-middle text-sm md:text-lg self-center">
          <span>MAIN MENU</span>
        </span>
        <Dropdown.Toggle.Chevron />
      </Dropdown.Toggle>
      <Dropdown.Menu widthClass={`${usefulLinks && usefulLinks.length > 0 ? 'w-64' : 'w-32'}`}>
        <Dropdown.Item>
          {!canViewTrips ? <></> : (
            <button
              type="button"
              onClick={handleViewTrips}
              className={navbarItemClasses}
              role="menuitem"
            >
              View trips
            </button>
          )}
          {usefulLinks && usefulLinks.length > 0 && usefulLinks.map((l, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <a href={l.url} className={navbarItemClasses} target="_blank" rel="noreferrer" key={`${l.url}-${index}`}>
              {l.linkText}
            </a>
          ))}
          <button
            type="button"
            onClick={handleSignOut}
            className={navbarItemClasses}
            role="menuitem"
          >
            Sign out
          </button>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  ) : <></>;
};

export default NavbarDropdown;
